// extracted by mini-css-extract-plugin
export var dropdownButton = "_1w-0";
export var fullWidthDropdownButton = "_1w-1";
export var icon = "_1w-3";
export var iconPlaceholder = "_1w-2";
export var menuItemRow = "_1w-8";
export var separator = "_1w-c";
export var shortcutContainer = "_1w-7";
export var shortcutIconLg = "_1w-6";
export var shortcutIconMd = "_1w-5";
export var shortcutIconSm = "_1w-4";
export var submenuChevron = "_1w-b";
export var submenuDropdown = "_1w-9";
export var submenuTriggerRow = "_1w-a";